import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_team_management-multi_user_evergreen_homepage_banner-view';
/**
 * View event for the multi user evergreen homepage for both web and mobile apps
 */
export function trackRetailerTeamManagementMultiUserEvergreenHomepageBannerView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
